module.exports = __webpack_public_path__ + "static/media/tutorial-book-attack.a208d163.png";